import type { Notification } from '../../../../lib/flotiq-client/types/external-api-response';
import type { UserLocalStorage } from '../../../../types/localStorage';

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../../lib/helpers';

import Loader from '../../../../components/Loader/Loader';

import NotificationsItem from './NotificationsItem';

export type OnNotificationsRead = (lastNotificationDate: string) => void;

const NotificationsContent = ({
  notifications,
  notificationsLoading,
  onNotificationsRead,
  testId,
}: {
  notifications: Notification[];
  notificationsLoading: boolean;
  onNotificationsRead?: OnNotificationsRead;
  testId?: string;
}) => {
  const { t } = useTranslation();

  const [lastNotificationDateBeforeOpen] = useState(() => {
    const localStorageData = localStorage.getItem('cms.user');
    const user: UserLocalStorage | undefined = localStorageData
      ? JSON.parse(localStorageData)
      : undefined;
    return user?.data?.config?.lastNotificationDate;
  });

  useEffect(() => {
    // Mark notifications as read when the component is opened
    if (!notificationsLoading && notifications?.length) {
      onNotificationsRead?.(notifications[0].internal.createdAt);
    }
  }, [notifications, notificationsLoading, onNotificationsRead]);

  if (notificationsLoading) {
    return (
      <Loader
        size="tiny"
        type="spinner-grid"
        additionalClasses="mx-auto my-3"
      />
    );
  }

  if (!notifications?.length) {
    return <p className="py-3">{t('Global.NoNotifications')}</p>;
  }

  return (
    <ul className="divide-y divide-blue-300 dark:divide-slate-800">
      {notifications.map((notification) => (
        <NotificationsItem
          key={notification.id}
          notification={notification}
          lastNotificationDateBeforeOpen={lastNotificationDateBeforeOpen}
          {...getTestProps(testId, notification.id, 'testId')}
        />
      ))}
    </ul>
  );
};

export default NotificationsContent;
